import withError from './with-error';

export default withError;
